import styled from "styled-components";
import SidebarItem from "./SidebarItem";
import {shark} from "../variables";

export default styled(SidebarItem)`
    color: ${shark}
`;

